<template>
  <div class="contentBox">
    <div class="container">
      <div class="article">
        <p class="text page-title">Yêu cầu hủy tài khoản game</p>
        <p class="strong">
          Vui lòng đọc kỹ Thỏa thuận hủy tài khoản game và đánh dấu vào ô xác
          nhận ở cuối trang.
        </p>
        <p class="text">Thỏa thuận hủy tài khoản game</p>
        <p class="text2">
          Người chơi thân mến, nếu sau khi cân nhắc kỹ lưỡng mà bạn vẫn quyết
          định hủy tài khoản game, xin vui lòng đọc kỹ, hiểu đầy đủ và đồng ý
          với toàn bộ nội dung của “Thỏa thuận hủy tài khoản game” (sau đây gọi
          là “Thỏa thuận”), đặc biệt lưu ý các điều khoản miễn trừ trách nhiệm,
          các điều kiện ràng buộc và điều khoản giải quyết tranh chấp và quyền
          tài phán. Chúng tôi xin đặc biệt lưu ý:
        </p>
        <p class="text2">
          Sau khi tài khoản game của bạn bị hủy, sẽ (có thể) phát sinh bao gồm
          nhưng không giới hạn các hậu quả sau:
        </p>
        <p class="title">
          Bạn sẽ không thể kiểm tra, truy cập, nhận, tiếp tục sử dụng hoặc khôi
          phục bất kỳ thông tin cá nhân nào, cũng như không có quyền yêu cầu
          chúng tôi kiểm tra các thông tin đó, bao gồm nhưng không giới hạn:
          thông tin tài khoản, thông tin nhân vật và dữ liệu cơ sở liên quan;
          Bạn sẽ được coi là tự nguyện từ bỏ tất cả tài sản trong game có thể
          tồn tại trong tài khoản hoặc nhân vật của bạn (bao gồm những tài sản
          đã có trong quá trình chơi và có thể phát sinh sau này). Chúng tôi có
          quyền tự xử lý các tài sản này mà không chịu bất kỳ trách nhiệm nào,
          và bạn cam kết không yêu cầu bồi thường hoặc truy cứu dưới bất kỳ hình
          thức nào đối với các tài sản đó; Tài khoản game sau khi hủy sẽ không
          thể khôi phục. Ngay cả khi bạn đăng nhập lại game bằng cùng thiết bị
          sau khi hủy, cũng sẽ tạo ra một tài khoản mới hoàn toàn.
        </p>
        <div class="height27"></div>
      </div>
      <div class="btn-box">
        <div class="rule-check">
          <div class="checkbox" @click="handleCheck">
            <img
              src="../../assets/img/deleteAccount/circle_s.png"
              alt=""
              class="check"
              :style="{ display: isClick ? `block` : 'none' }"
            />
          </div>
          <p class="rule">I have read carefully and agreed1</p>
        </div>
        <div
          class="btn unactive"
          :class="isClick ? 'active' : ''"
          @click="handleConfirm"
        >
          Next
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      isClick: false,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    handleCheck() {
      this.isClick = !this.isClick;
    },
    handleConfirm() {
      if (!this.isClick) {
        return;
      }
      // this.$router.push("/main/deletion/chooseGame");
      this.$router.push({
        path: "/main/deletion/chooseLogin",
      });
    },
  },
};
</script>


<style scoped lang="scss">
@import "./css/index.css";
</style>
